import styled from "styled-components";

import { getToneTokens } from "../../styles/shared";

export const Sticky = styled.div`
  position: ${({ $sticky }) => ($sticky ? "sticky" : "static")};
  top: ${({ $sticky }) => ($sticky ? "0" : "auto")};
  z-index: 5;
  background: ${({ theme }) => theme.surface};
  border: 1px solid ${({ theme }) => theme.border};
  border-radius: 16px;
  padding: 14px 18px;
  margin-bottom: 16px;
`;

export const Row = styled.div`
  display: flex;
  align-items: center;
  gap: 14px;
  flex-wrap: wrap;
`;

export const BackButton = styled.button`
  appearance: none;
  background: transparent;
  border: 1px solid ${({ theme }) => theme.border};
  border-radius: 8px;
  padding: 6px 10px;
  font-size: 0.85rem;
  color: ${({ theme }) => theme.textPrimary};
  display: inline-flex;
  align-items: center;
  gap: 6px;
  cursor: pointer;

  &:hover {
    background: ${({ theme }) => theme.surfaceAlt};
  }

  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.accent};
    outline-offset: 2px;
  }
`;

export const Identity = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
  flex: 1;
`;

export const TextStack = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
`;

export const Title = styled.h1`
  margin: 0;
  font-size: 1.25rem;
  font-weight: 600;
  color: ${({ theme }) => theme.textPrimary};
  line-height: 1.2;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const Subtitle = styled.span`
  font-size: 0.85rem;
  color: ${({ theme }) => theme.textSecondary};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const Badges = styled.div`
  display: inline-flex;
  flex-wrap: wrap;
  gap: 6px;
  align-items: center;
`;

export const Badge = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  border-radius: 999px;
  padding: 2px 10px;
  font-size: 0.72rem;
  font-weight: 600;
  background: ${({ theme, $tone = "neutral" }) =>
    getToneTokens(theme, $tone).background};
  color: ${({ theme, $tone = "neutral" }) => getToneTokens(theme, $tone).text};
  border: 1px solid
    ${({ theme, $tone = "neutral" }) => getToneTokens(theme, $tone).border};
`;

export const Actions = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  margin-left: auto;
`;

export const PrimaryButton = styled.button`
  background: ${({ theme }) => theme.accent};
  color: var(--ink-on-accent);
  border: 0;
  border-radius: 8px;
  padding: 7px 14px;
  font-size: 0.85rem;
  font-weight: 600;
  cursor: pointer;

  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.accent};
    outline-offset: 2px;
  }
`;

export const MenuButton = styled.button`
  appearance: none;
  background: transparent;
  border: 1px solid ${({ theme }) => theme.border};
  color: ${({ theme }) => theme.textPrimary};
  border-radius: 8px;
  width: 32px;
  height: 32px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  &:hover {
    background: ${({ theme }) => theme.surfaceAlt};
  }

  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.accent};
    outline-offset: 2px;
  }
`;

export const MenuWrapper = styled.div`
  position: relative;
`;

export const MenuList = styled.ul`
  position: absolute;
  top: calc(100% + 6px);
  right: 0;
  margin: 0;
  padding: 6px;
  list-style: none;
  background: ${({ theme }) => theme.surface};
  border: 1px solid ${({ theme }) => theme.border};
  border-radius: 10px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
  min-width: 180px;
  z-index: 20;
`;

export const MenuItem = styled.li`
  > button {
    width: 100%;
    text-align: left;
    background: transparent;
    border: 0;
    padding: 7px 10px;
    border-radius: 6px;
    font-size: 0.85rem;
    cursor: pointer;
    color: ${({ theme, $danger }) =>
      $danger ? theme.dangerText : theme.textPrimary};
  }
  > button:hover {
    background: ${({ theme }) => theme.surfaceAlt};
  }
`;
